export enum EMAIL_TYPES {
    SIGNUP = 'SIGNUP',
    RESET_PASSWORD = 'RESET_PASSWORD',
    INVITE_CANDIDATE = 'INVITE_CANDIDATE',
    INVITE_EMPLOYEE = 'INVITE_EMPLOYEE',
    VALIDATION_LOGIC_TEST_INVITATION = 'VALIDATION_LOGIC_TEST_INVITATION',
    CANDIDATE_REMINDER = 'CANDIDATE_REMINDER'
}
